import { CheckCircle2 } from "lucide-react";
import { ABOUT } from "@/lib/siteData";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 sm:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl shadow-green-900/10 aspect-[4/3]">
              <img
                src={ABOUT.image}
                alt="Garden pond with rocks and plants"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-green-700 text-white rounded-2xl px-6 py-5 shadow-lg">
              <div className="text-2xl font-extrabold" style={{ fontFamily: "Outfit, sans-serif" }}>
                All-year
              </div>
              <div className="text-xs uppercase tracking-widest text-green-100">
                Pond &amp; garden care
              </div>
            </div>
          </div>

          <div>
            <span className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest">
              {ABOUT.eyebrow}
            </span>
            <h2
              data-testid="about-headline"
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-green-950 tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {ABOUT.heading}
            </h2>
            {ABOUT.body.map((p, i) => (
              <p key={i} className="mt-5 text-base lg:text-lg text-slate-600 leading-relaxed">
                {p}
              </p>
            ))}

            <div className="mt-8 grid grid-cols-3 gap-4">
              {ABOUT.stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl border border-green-100 bg-green-50/50 px-4 py-5 text-center"
                  data-testid={`about-stat-${s.label}`}
                >
                  <div className="text-2xl font-extrabold text-green-700" style={{ fontFamily: "Outfit, sans-serif" }}>
                    {s.value}
                  </div>
                  <div className="text-xs text-slate-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2">
              {["One-off clean-ups", "Regular maintenance", "Award-winning"].map((t) => (
                <span key={t} className="inline-flex items-center gap-2 text-sm text-green-900 font-medium">
                  <CheckCircle2 className="w-4 h-4 text-green-600" /> {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
